import RedisStatus from "../js/components/coreServices/RedisStatus.react";

export default RedisStatus;
